/* tslint:disable */
/* eslint-disable */
/**
 * Property Search API
 * Search properties and get aggregated info about areas.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MappingDto
 */
export interface MappingDto {
    /**
     * 
     * @type {string}
     * @memberof MappingDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof MappingDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof MappingDto
     */
    nameId: string;
    /**
     * 
     * @type {string}
     * @memberof MappingDto
     */
    connectionType: string;
    /**
     * 
     * @type {string}
     * @memberof MappingDto
     */
    mlsSource: string;
    /**
     * 
     * @type {string}
     * @memberof MappingDto
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof MappingDto
     */
    subType: string;
    /**
     * 
     * @type {string}
     * @memberof MappingDto
     */
    display?: MappingDtoDisplayEnum;
    /**
     * 
     * @type {string}
     * @memberof MappingDto
     */
    displayRewrite?: string;
}


/**
 * @export
 */
export const MappingDtoDisplayEnum = {
    Hidden: 'Hidden',
    Rewrite: 'Rewrite',
    AsIs: 'As Is'
} as const;
export type MappingDtoDisplayEnum = typeof MappingDtoDisplayEnum[keyof typeof MappingDtoDisplayEnum];


/**
 * Check if a given object implements the MappingDto interface.
 */
export function instanceOfMappingDto(value: object): value is MappingDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('nameId' in value) || value['nameId'] === undefined) return false;
    if (!('connectionType' in value) || value['connectionType'] === undefined) return false;
    if (!('mlsSource' in value) || value['mlsSource'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('subType' in value) || value['subType'] === undefined) return false;
    return true;
}

export function MappingDtoFromJSON(json: any): MappingDto {
    return MappingDtoFromJSONTyped(json, false);
}

export function MappingDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MappingDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'nameId': json['nameId'],
        'connectionType': json['connectionType'],
        'mlsSource': json['mlsSource'],
        'type': json['type'],
        'subType': json['subType'],
        'display': json['display'] == null ? undefined : json['display'],
        'displayRewrite': json['displayRewrite'] == null ? undefined : json['displayRewrite'],
    };
}

export function MappingDtoToJSON(json: any): MappingDto {
    return MappingDtoToJSONTyped(json, false);
}

export function MappingDtoToJSONTyped(value?: MappingDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'nameId': value['nameId'],
        'connectionType': value['connectionType'],
        'mlsSource': value['mlsSource'],
        'type': value['type'],
        'subType': value['subType'],
        'display': value['display'],
        'displayRewrite': value['displayRewrite'],
    };
}

